import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useStyles } from './styles';
import { type WithoutApproved } from '../../History/types';

type TransactionStatusProps = {
  status: WithoutApproved;
};

const TransactionStatus = ({ status }: TransactionStatusProps) => {
  const classes = useStyles();
  const { t } = useTranslation(['history']);

  return (
    <div className={classes.statusWrapper}>
      <div className={classes.statusIconWrapper}>
        <div className={clsx(classes.statusIcon, classes[status])} />
      </div>
      <div>{t(`transaction status.${status}`)}</div>
    </div>
  );
};

export default TransactionStatus;
